import { render } from "../templates/edit-scenario-products.html?vue&type=template&id=3c58844f"
import script from "./edit-scenario-products.vue?vue&type=script&lang=js"
export * from "./edit-scenario-products.vue?vue&type=script&lang=js"

import "../styles/edit-scenario-products.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/var/www/lbr.ru/crm/vue_source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__